import React from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoText,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources, AppPermissions } from '@erecruit/types';
import { Authorize } from '@erecruit/modules';

import SectionContextMenu from '../SectionContextMenu';
import { BaseSectionProps } from '../../types';

const { FormattedMessage } = Intl;

export default ({
  data,
  expanded,
  onEdit,
  isMyOwn,
}: BaseSectionProps<Resources.Position>) => {
  const {
    clientProject,
    folderGroup,
    industry,
    name,
    numberOfPositions,
    positionDescription,
    positionType,
    primaryDepartment,
    supervisor,
    workHours,
  } = data;

  return (
    <FlexItem>
      <CardInfo
        showDetails={expanded}
        title={
          <H3 align="center">
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.title}
            />
          </H3>
        }
        extra={
          <Authorize
            permission={`(${AppPermissions.EditPositions} | (${AppPermissions.EditMyOwnPositions} & ${isMyOwn}))`}
          >
            <SectionContextMenu section="aboutPosition" onEdit={onEdit} />
          </Authorize>
        }
      >
        <CardInfoItem
          isDetail
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.clientProject}
            />
          }
          type={CardInfoValueType.SingleSelect}
          value={clientProject?.name}
        />
        <CardInfoItem
          isDetail
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.folderGroup}
            />
          }
          type={CardInfoValueType.SingleSelect}
          value={folderGroup?.name}
        />
        <CardInfoText
          isDetail
          value={industry?.name}
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.industry}
            />
          }
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.numberOfPositions}
            />
          }
          type={CardInfoValueType.Number}
          value={numberOfPositions}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={
                messageIds.vms.positionRecord.aboutPosition.positionDescription
              }
            />
          }
          type={CardInfoValueType.RichText}
          value={positionDescription}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.positionTitle}
            />
          }
          type={CardInfoValueType.SingleSelect}
          value={name}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.positionType}
            />
          }
          type={CardInfoValueType.SingleSelect}
          value={positionType?.name}
        />
        <CardInfoItem
          isDetail
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.primaryDepartment}
            />
          }
          type={CardInfoValueType.SingleSelect}
          value={primaryDepartment?.name}
        />
        <CardInfoItem
          isDetail
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.supervisor}
            />
          }
          type={CardInfoValueType.SingleSelect}
          value={supervisor?.name}
        />
        <CardInfoText
          isDetail
          label={
            <FormattedMessage
              id={messageIds.vms.positionRecord.aboutPosition.workHours}
            />
          }
          value={workHours}
        />
      </CardInfo>
    </FlexItem>
  );
};
